import {
  ProfileIdentifier,
  ProfilePlayer,
  ProfileSuspension,
  ProfileUser,
} from '../../types'

export enum ActionType {
  SET_ITEM = 'SET_ITEM',
  SET_PLAYERS = 'SET_PLAYERS',
  SET_LOADED_PLAYERS = 'SET_LOADED_PLAYERS',
  SET_SHOW_STATS = 'SET_SHOW_STATS',
  SET_NOTIFICATION_SETTINGS_OPEN = 'SET_NOTIFICATION_SETTINGS_OPEN',
  SET_EDIT_OPEN = 'SET_EDIT_OPEN',
}

export interface ProfileState {
  item: ProfileUser
  selfPlayerIds: ProfileIdentifier[]
  players: ProfilePlayer[]
  loadedPlayers: boolean
  showStats: boolean
  isNotificationSettingsOpen: boolean
  isEditOpen: boolean
}

export type ProfileAction =
  | { type: ActionType.SET_ITEM; payload: ProfileUser }
  | {
      type: ActionType.SET_PLAYERS
      payload: {
        players: ProfilePlayer[]
        selfPlayerIds: ProfileIdentifier[]
        showStats: boolean
      }
    }
  | { type: ActionType.SET_LOADED_PLAYERS; payload: boolean }
  | { type: ActionType.SET_SHOW_STATS; payload: boolean }
  | { type: ActionType.SET_NOTIFICATION_SETTINGS_OPEN; payload: boolean }
  | { type: ActionType.SET_EDIT_OPEN; payload: boolean }

export interface ProfileContextValue extends ProfileState {
  suspensions: ProfileSuspension[] | undefined
  suspensionLoading: boolean
  isSuspended: boolean
  readItem: (forceApi?: boolean) => Promise<void>
  loadPlayers: () => Promise<void>
  refreshSuspensions: () => Promise<void>
  setShowStats: (value: boolean) => void
  openNotificationSettings: () => void
  closeNotificationSettings: () => void
  openEditModal: () => void
  closeEditModal: () => void
  selectedPlayer: ProfilePlayer | null
  selectedPlayerId: string | null
  selectPlayer: (player?: ProfilePlayer | null) => void
  /**
   * Whether the current user is PRIMARY (admin) for the selected player, from
   * that player's `is_primary` in /users/me/family. Only a primary can edit the
   * player (and manage family there); a non-primary gets the read-only Family
   * Members list instead.
   */
  isPrimaryForSelectedPlayer: boolean
}
